import { makeAutoObservable } from 'mobx'
import { cartMobx, discountMobx } from '..'

const getDefaultSwapBuy = () => {
  return {
    parentCartItemPk: '',
  }
}

/**
 * 操作换购品选择模块
 */
class DoSwapBuy {
  constructor () {
    makeAutoObservable(this)
  }

  /** 换购数据 */
  doSwapBuy: IDoSwapBuy = getDefaultSwapBuy()

  /** 展示数量 */
  showAddCnt: number = 0

  /** 选择换购品 */
  pick ({ parentCartItemPk }: { parentCartItemPk?: string }) {
    if (parentCartItemPk) {
      const doSwapBuy = {
        name: discountMobx.discountResult.singleItemSwapBuyMap[parentCartItemPk]?.activityName,
        products: discountMobx.singleSwapBuyMap[parentCartItemPk]?.viewActivityProducts,
        parentCartItem: cartMobx.viewCartItems.find(item => parentCartItemPk === item.pk),
        parentCartItemPk,
      }
      this.doSwapBuy = doSwapBuy
    } else {
      this.doSwapBuy = getDefaultSwapBuy()
    }
  }

  /** 重置换购品 */
  reset () {
    this.doSwapBuy = getDefaultSwapBuy()
  }

  /** 设置展示数量 */
  setShowAddCnt (count: number) {
    this.showAddCnt = count
  }
}

export default new DoSwapBuy()
